export enum ERemoteConfigParameter {
  CUSTOMER_CHANNEL_STATUS = 'CUSTOMER_CHANNEL_STATUS',
  ONEBOARD_PLUS_CLASSROOM_LINK = 'ONEBOARD_PLUS_CLASSROOM_LINK',
  SUB_ORGANIZATION_FIELD = 'SUB_ORGANIZATION_FIELD',
  PAY4U_OVERDUE_ORDER = 'PAY4U_OVERDUE_ORDER',
}

export const FEATURE_DISABLEMENT_LIST = [
  ERemoteConfigParameter.CUSTOMER_CHANNEL_STATUS,
  ERemoteConfigParameter.SUB_ORGANIZATION_FIELD,
];
